<template>
  <v-card min-width="326">
    <v-card-title test-tag="tag-211"><T>Календарь</T></v-card-title>
    <v-divider></v-divider>
    <v-calendar-weekly
      :locale="$store.getters.locale_metadata.Language.replace('_', '-')"
      :weekdays="[1,2,3,4,5,6,0]"
      :weekday-format="weekdayFormat"
      :end="month"
    >
      <template  v-slot:day="date">
        <slot name="day">
          <div class="block" :style="getBlockStyle(date)">{{getBlockContent(date)}}</div>
        </slot>
        </template>
    </v-calendar-weekly>
  </v-card>
</template>

<script>
export default {
  props: {
    config: [Object, Array], 
    max_days:{
      type: Number,
      default: 21
    },
  },
  methods: {
    weekdayFormat(date_dict) {
      let days = [
        this.$t('вс'),
        this.$t('пн'),
        this.$t('вт'),
        this.$t('ср'),
        this.$t('чт'),
        this.$t('пт'),
        this.$t('сб'),
      ]
      return days[date_dict.weekday]
    },
    getInterceptedInterval(date){
      if (!this.config) {
        return undefined
      }

      // let intercepted_interval = undefined
      let intervals = JSON.parse(JSON.stringify(this.config))
      
      for (const [idx, interval] of intervals.reverse().entries()) {
        
        if (interval.mode == 'DAYOFWEEK') {
          if (interval.day_of_week.includes(date.weekday == 0 ? 6 : date.weekday - 1)) {
            return [Math.abs(intervals.length - 1 - idx), interval]
          }
        } else {
          let current_date = new Date(date.date)
          let int_start = new Date(interval.str_date_start)
          let int_end = new Date(interval.str_date_end)
          


          if ((current_date >= int_start) && (current_date <= int_end)) {
            return [Math.abs(intervals.length - 1 - idx), interval]
          }
        }
      }

      return undefined
    },
    getBlockStyle(date){
      let pair = this.getInterceptedInterval(date)

      if (pair) {
        let [idx, interval] = pair

        const colors = this.colors
        const color = colors[idx % colors.length]

        if (interval.is_workday) {
          return `background-color: ${color}`
        } else {
          return `background-color: var(--v-secondary-base); text-align: center`
        }
      }

      return 'line-height: 2em; color: black'
    },
    getBlockContent(date){
      let pair = this.getInterceptedInterval(date)

      if (pair) {
        let interval = pair[1]

        if (interval.is_workday) {
          return `${interval.str_time_start}   ${interval.str_time_end}`
        } else {
          return `___`
        }
      }

      return '<?>'
    }
  },
  computed: {
    today(){
      return new Date()
    },
    month(){
      let month = new Date(this.today)
      month.setDate(this.today.getDate() + this.max_days)
      return month
    },
    colors(){
      return [
        'var(--v-primary-base)',
        'var(--v-info-base)',
        'var(--v-primary-darken4)',
        'var(--v-info-darken3)',
        'var(--v-info-darken1)',
        'var(--v-primary-darken1)',
        'var(--v-info-lighten3)',
        'var(--v-primary-darken3)',
        'var(--v-primary-darken2)',
        'var(--v-info-lighten2)',
        'var(--v-info-lighten1)',
        'var(--v-info-darken2)',
      ]
    }
  }
}
</script>

<style scoped>
.block {
  height: 2.5em;
  margin: .5em .1em;
  content: " ";
  line-height: 1em;
  font-family: monospace;
  /* width: 100%; */
  border-radius: .3em;
  overflow-y: visible;
  color: white;
  padding: .3em;

  font-size: .8rem;
  text-align: center;
}
</style>